/**
 * Helper functions for EditVendorPageV2 component
 */
import { EMPTY_STRING } from './EditVendorPageV2.constants';

/**
 * Helper function to safely get nested value
 */
export const getNestedValue = (obj, path, defaultValue = EMPTY_STRING) => {
	if (!obj || typeof obj !== 'object') return defaultValue;
	const keys = path.split('.');
	let value = obj;
	for (let index = 0; index < keys.length; index += 1) {
		if (value === null || value === undefined || typeof value !== 'object') {
			return defaultValue;
		}
		value = value[keys[index]];
	}
	return value !== null && value !== undefined ? value : defaultValue;
};

/**
 * Helper to get document type from file extension
 */
export const getDocumentType = (fileKey) => {
	if (!fileKey) return 'PDF';
	const ext = fileKey.split('.').pop()?.toLowerCase();
	if (ext === 'jpg' || ext === 'jpeg') return 'JPG';
	if (ext === 'png') return 'PNG';
	return 'PDF';
};

/**
 * Format error message from API response
 */
export const formatErrorMessage = (error) => {
	if (typeof error === 'string') {
		return error;
	}
	if (error && typeof error === 'object') {
		if (error.message && typeof error.message === 'string') {
			return error.message;
		}
		if (error.message && typeof error.message === 'object') {
			// Handle validation errors that are objects
			return Object.entries(error.message)
				.map(([key, value]) => `${key}: ${value}`)
				.join('; ');
		}
		if (error.details && error.details.message) {
			return error.details.message;
		}
	}
	return 'An error occurred';
};
